import { Cart } from '@site-module/cart.js';

export default function initCart() {
    const cartHandling = new Cart();

    if (! cartHandling.root_element) {
        return;
    }

    // clicking the mask closes the modal
    cartHandling.root_element.onclick = (event) => {
        event.preventDefault();
        event.stopPropagation();
        cartHandling.modalClose();
    };

    // catch clicks inside the actual cart
    document.getElementById('cart-inner').onclick = (event) => {
        event.stopPropagation();
    };

    // take over the add-to-order button handling
    cartHandling.getButtons().forEach((button) => {
        button.onclick = (event) => {
            event.preventDefault();
            event.stopPropagation();
            if (button.getAttribute('disabled')) {
                return;
            }
            cartHandling.addToCart(button);
        };
    });

    // buttons might skip cart, but should still update datalayer beforeunload
    document.querySelectorAll('[data-beforeunload-handle="cart"]').forEach((button) => {
        button.onclick = function() {
            cartHandling.pushToDataLayer(button.dataset);
        };
    });

    // enable the cart toggle buttons
    document.querySelectorAll('[data-toggle="cart"], [aria-controls="cart"]').forEach((button) => {
        button.onclick = function(event) {
            event.preventDefault();
            event.stopPropagation();

            cartHandling.modalToggle(button);
        };
    });

    cartHandling.updateCart();
}
